import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  const navigate = useNavigate();

  // Auto-redirect to home after 8 seconds
  useEffect(() => {
    const t = setTimeout(() => navigate('/'), 8000);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <>
      <SEO title="Page Not Found" description="The page you are looking for does not exist." />

      <div className="pt-16 min-h-screen flex items-center justify-center" style={{ background: '#FAFAF8' }}>
        <div className="max-w-lg w-full mx-auto px-6 py-20 text-center">

          {/* Precision crosshair motif */}
          <div className="flex justify-center mb-10">
            <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="36" cy="36" r="28" stroke="#E2E8F0" strokeWidth="1.5"/>
              <circle cx="36" cy="36" r="16" stroke="#E2E8F0" strokeWidth="1"/>
              <circle cx="36" cy="36" r="4" fill="#F97316"/>
              <line x1="8" y1="36" x2="20" y2="36" stroke="#CBD5E1" strokeWidth="1.5"/>
              <line x1="52" y1="36" x2="64" y2="36" stroke="#CBD5E1" strokeWidth="1.5"/>
              <line x1="36" y1="8" x2="36" y2="20" stroke="#CBD5E1" strokeWidth="1.5"/>
              <line x1="36" y1="52" x2="36" y2="64" stroke="#CBD5E1" strokeWidth="1.5"/>
            </svg>
          </div>

          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-safety mb-3">
            Error 404
          </p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-steel-900 uppercase tracking-tight mb-4">
            Out of Range
          </h1>
          <p className="font-body text-steel-500 text-base leading-relaxed mb-10">
            The page you're looking for doesn't exist or has moved.
            You'll be redirected to the home page automatically.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => navigate('/')}
              className="bg-safety text-white font-heading uppercase text-sm tracking-wider px-8 py-3.5 hover:-translate-y-0.5 hover:bg-orange-600 transition-all duration-200"
            >
              Back to Home
            </button>
            <button
              onClick={() => navigate('/products')}
              className="border-2 border-steel-200 text-steel-700 font-heading uppercase text-sm tracking-wider px-8 py-3.5 hover:border-steel-900 hover:text-steel-900 transition-all duration-200"
            >
              View Products
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
